import { c as _c } from "react/compiler-runtime";
import { IcoInfo16, LogoIcoVerified } from '@onefootprint/icons';
import { Tooltip } from '@onefootprint/ui';
import { Trans, useTranslation } from 'react-i18next';
export const PoweredByVerified = () => {
  const $ = _c(15);
  const {
    t
  } = useTranslation("idv2");
  let t0;
  if ($[0] !== t) {
    t0 = t(_temp2);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <span className="text-label-2 text-primary">{t0}</span>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LogoIcoVerified />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <Trans ns="idv2" i18nKey={_temp} components={{
      oneClickSignup: t1,
      icon: t2
    }} />;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp3);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IcoInfo16 color="tertiary" className="ml-1" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <Tooltip content={t4} side="bottom">{t5}</Tooltip>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <p className="text-body-2 text-tertiary flex items-center gap-1 justify-center">{t3}{t6}</p>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp($) {
  return $.identify.otp.verifiedPrefill.poweredBy;
}
function _temp2($_0) {
  return $_0.identify.otp.verifiedPrefill.oneClickSignup;
}
function _temp3($_1) {
  return $_1.identify.otp.verifiedPrefill.tooltip;
}